module.exports = __webpack_public_path__ + "static/media/GOFLiteBrite.4927dcb3.png";